import SocketIO from 'socket.io-client'
import axios from 'axios'
import vm from '../main.js'

const adminToken = 'asdasdasaaa'
// const serverUrl = 'http://localhost:3000'
const serverUrl = 'https://msp22chat.herokuapp.com:443'

export default {

  connection: () => {
    return SocketIO(serverUrl, { autoConnect: false })
  },

  socketConnect: (token) => {
    vm.$socket.io.opts.query = { token }
    vm.$socket.connect()
    // console.log('server connected', vm.$socket)
  },

  validateUser: (user) => {
    return axios.post(`${serverUrl}/api/users/validate`, user)
  },

  getChats: (token) => {
    return axios.get(`${serverUrl}/api/chats/`, { headers: { token } })
  },

  getChatMessages: (chatId, token, params) => {
    return axios.get(`${serverUrl}/api/chats/${chatId}/messages`, { headers: { token }, params })
  },

  sendMessage: (message) => {
    return new Promise((resolve, reject) => {
      vm.$socket.emit("send_message", message, (result) => {
        return result.error ? reject(result.error) : resolve(result)
      })
    })
  },

  sendFile: async (token, message, filedata) => {
    console.log('upload file', message.data.name)
    return axios.post('https://xn--22-9kcqjffxnf3b.xn--p1ai/api/v1/chat/files/', filedata, { headers: { filename: message.data.name, auth: token } })
      .then(response => {
        console.log('file uploaded', response.data)
        message.data.size = response.data.data.size,
        message.data.fileId = response.data.data.fileId
        console.log('send message', message)
        return new Promise((resolve, reject) => {
          vm.$socket.emit("send_message", message, (result) => {
            return result.error ? reject(result.error) : resolve(result)
          })
        })
      })     
    
  },

  openChat: (chatId) => {
    return new Promise((resolve, reject) => {
      vm.$socket.emit("open_chat", { chatId }, (result) => {
        return result.error ? reject(result.error) : resolve(result)
      })
    })
  },

  findChat: (token, userId) => {
    return axios.get(`${serverUrl}/api/chats/find?userId=${userId}`, { headers: { token } })
  },

  newChat: (title, status, subscribers) => {
    return axios.post(`${serverUrl}/api/chats/new`, { title, status, subscribers }, { headers: { token: adminToken } })
  },

  updateChat: (chatId, title, status, subscribers) => {
    return axios.put(`${serverUrl}/api/chats/${chatId}/`, { title, status, subscribers }, { headers: { token: adminToken } })
  },



}